import { connect } from 'react-redux';

import SidebarProfile from './';

const mapStateToProps = state => ({
  identity: state.identity
});

export default connect(mapStateToProps, null)(SidebarProfile);
